module.exports = __webpack_public_path__ + "media/images/restrictions-topbar-59342a080491a79c6587104cff6eba60.svg";